import React from 'react';
import { Controller } from 'react-hook-form';
import { IconArrowRight } from '@tabler/icons-react';
import { Button } from '@planne-software/uni/Button';
import { Input } from '@planne-software/uni/Input';

import { useTranslate } from '@src/core/hooks';
import {
  AuthCardButtonWrapper,
  AuthCardRoot,
  AuthCardSubtitle,
  AuthCardTextGroup,
  AuthCardTitle,
  ButtonGroup,
} from '@src/features/customers';

import { useRecoveryEmailForm } from '../hooks/useRecoveryEmailForm';

type PasswordRecoveryEmailCardProps = {
  initialEmail: string;
  onBack: () => void;
};

export const PasswordRecoveryEmailCard = (props: PasswordRecoveryEmailCardProps) => {
  const { initialEmail, onBack } = props;
  const { i18n } = useTranslate();

  const { control, errors, loading, isSubmitEnabled, onSubmit } = useRecoveryEmailForm({ initialEmail });

  return (
    <AuthCardRoot data-testid='password-recovery-email-card'>
      <AuthCardTextGroup>
        <AuthCardTitle>{i18n('checkout_auth_recovery_title')}</AuthCardTitle>
        <AuthCardSubtitle>{i18n('checkout_auth_recovery_email_subtitle')}</AuthCardSubtitle>
      </AuthCardTextGroup>

      <form onSubmit={onSubmit} noValidate>
        <AuthCardRoot>
          <Controller
            name='email'
            control={control}
            render={({ field: { onChange, value, name, ref, ...rest } }) => (
              <Input
                type='email'
                label={i18n('checkout_auth_email_label')}
                placeholder={i18n('checkout_auth_email_placeholder')}
                name={name}
                id={name}
                value={value ?? ''}
                onChange={onChange}
                error={!!errors.email}
                disabled={loading}
                helperText={errors.email?.message}
                autoComplete='email'
                ref={ref}
                size='medium'
                {...rest}
              />
            )}
          />

          <ButtonGroup>
            <AuthCardButtonWrapper>
              <Button
                type='submit'
                fullWidth
                loading={loading}
                disabled={!isSubmitEnabled || loading}
                endSlot={<IconArrowRight size={20} aria-hidden />}
              >
                {i18n('checkout_auth_continue_cta')}
              </Button>
            </AuthCardButtonWrapper>

            <AuthCardButtonWrapper>
              <Button type='button' variant='slim' fullWidth disabled={loading} onClick={onBack}>
                {i18n('checkout_auth_back_cta')}
              </Button>
            </AuthCardButtonWrapper>
          </ButtonGroup>
        </AuthCardRoot>
      </form>
    </AuthCardRoot>
  );
};

export default PasswordRecoveryEmailCard;
